import { GraduationCap, Building2, Presentation } from "lucide-react";

export const FUNNELS = {
  student: {
    path: "/for-students",
    icon: GraduationCap,
    questions: ["stage", "domain", "start", "goal"],
    image: "https://images.unsplash.com/photo-1758270705290-62b6294dd044?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    accent: "from-amber-500 via-orange-500 to-rose-500",
    accentText: "from-amber-600 via-orange-500 to-rose-600",
    tint: "from-amber-50 via-orange-50 to-rose-50",
    chip: "bg-amber-100 text-amber-800",
    seoTitle: "Job-Linked Courses for Students & Freshers | Classroom to Corporate",
    seoDesc: "Get hired before you finish the course. Free career consultation and placement guide for college students and fresh graduates in Ahmedabad and across India.",
  },
  employer: {
    path: "/for-employers",
    icon: Building2,
    questions: ["hires", "role", "timeline", "size"],
    image: "https://images.unsplash.com/photo-1577962917302-cd874c4e31d2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    accent: "from-sky-500 via-cyan-500 to-emerald-500",
    accentText: "from-sky-600 via-cyan-600 to-emerald-600",
    tint: "from-sky-50 via-cyan-50 to-emerald-50",
    chip: "bg-sky-100 text-sky-800",
    seoTitle: "Hire Trained, Job-Ready Freshers | Classroom to Corporate for Employers",
    seoDesc: "Stop interviewing 50 freshers to hire one. Get candidates trained on your exact requirements. Free hiring consultation and fresher hiring checklist.",
  },
  expert: {
    path: "/for-experts",
    icon: Presentation,
    questions: ["experience", "domain", "hours", "taught"],
    image: "https://images.unsplash.com/photo-1580894732930-0babd100d356?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    accent: "from-rose-500 via-pink-500 to-orange-400",
    accentText: "from-rose-600 via-pink-600 to-orange-500",
    tint: "from-rose-50 via-pink-50 to-orange-50",
    chip: "bg-rose-100 text-rose-800",
    seoTitle: "Teach Online as an Industry Expert | Classroom to Corporate",
    seoDesc: "Your experience is worth more than your salary slip. Teach job-ready skills online on your schedule. Free onboarding call and trainer starter kit.",
  },
};
